export default __webpack_public_path__ + "static/media/arrow-left.a689b6ea.svg";